import React, { Fragment, useState } from 'react';
import MailProButton from "../../UI/MailProButton";
import { withSnackbar } from 'notistack';
import { CommonConfirmationDialogV2Component } from 'components';
import { renderLogicUtil } from 'views/Pma/RenderLogicUtil';
import { showErrorNotification, showSuccessNotification } from 'common/helpers';
import { sendSystemNoteToAllHomeowners } from "../Common/NoteServices";
import { noteUtils } from 'views/Pma/MailPro/components/Notes/Common/NoteUtils';
import { LOG_MODULES, LOG_CODE_PREFIX, trackException } from 'common/errorTracker';

const SystemNoteToAllHomeownersComponent = ({ 
  properties,
  cameFrom,
  isBlocked,
  agentData,
  currentArea,
  disabled,
  pendingNoteHomeownerCount,
  anniversaryHomeownersCount,
  handleRootLoading,
  classes,
  ...rest
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { isMemberOfTeam } = agentData;

  const handleSendSystemNotes = async () => {
    try {
      setIsLoading(true);
      handleRootLoading(true);
      
      const { mlsAreaID, mlsNeighborhood } = currentArea || {};

      const anniversarySkippableMailProIds=  noteUtils.getMailProIDsWhereAnniversaryNoteCanbeSkipped(properties, cameFrom);

      
      // Calculate API input data similar to fetchAndSetSystemNote
      const apiData = {
        areaID: mlsAreaID,
        areaName: mlsNeighborhood,
        homeOwnerDetails: properties ? properties.map(ho => {
          const { HOQuickFilterData: { isAbsentee }} = ho;

          return {
            mailerProID: ho.mailerProID,
            anniversaryCount: renderLogicUtil.getHOAnniversaryNumber(ho),
            isAbsenteeHO: isAbsentee,
            isMemberOfTeam
          };
        }).filter(ho => anniversarySkippableMailProIds.includes(ho.mailerProID)) : []
      };
      // Call the API to send system notes to all homeowners
      await sendSystemNoteToAllHomeowners(apiData);
      
      showSuccessNotification(rest, 'Annniversary notes sent successfully to all homeowners. Reloading MailPro...', 6000);
      setTimeout(() => {
        window.location.reload(); // Refresh the page after success
      }, 6000);
    } catch (error) {
      console.log("error", error);
      trackException({
        module: LOG_MODULES.MAILPRO,
        code: `${LOG_CODE_PREFIX.MAILPRO}SYSTEM_NOTE_SEND_ALL_FAILED`,
        error,
        data: { mlsAreaID: (currentArea || {}).mlsAreaID },
      });
      showErrorNotification(rest, 'Failed to send anniversary notes', 6000);
    } finally {
      setIsLoading(false);
      handleRootLoading(false);
    }
  };

  return (
    <div>
      {pendingNoteHomeownerCount > 0 && (
        <CommonConfirmationDialogV2Component
          title={<Fragment>You are sending an Anniversary Note to <span style={{fontWeight: "bold"}}>ALL {pendingNoteHomeownerCount}</span> Homeowner{pendingNoteHomeownerCount > 1 ? 's' : ''} for this mailing</Fragment>}
          //Are you certain you want to send an Anniversary Note to all 
          subtitle={`Are you certain you want to send an Anniversary Note to all ${pendingNoteHomeownerCount} of your Homeowner${pendingNoteHomeownerCount > 1 ? 's' : ''}?`}
          methodToCallOnConfirmation={handleSendSystemNotes}
          key={'MailProSystemNoteToAllHomeowners-Send'}
          cancelButtonText={'CANCEL'}
          confirmationButtonText={'YES, send to all Homeowners'}
          bodyStyle={{ paddingTop: '7px', paddingBottom: '7px' }}
          isDisabled={isLoading || disabled}
        >
          <MailProButton
            key={"send_system_note_to_all"}
            variant="filled"
            label={anniversaryHomeownersCount === pendingNoteHomeownerCount ? <Fragment><span className={classes.newText}>NEW</span>CLICK HERE TO SEND ANNIVERSARY NOTES TO <span style={{fontWeight: "bold"}}>ALL</span> HOMEOWNERS FOR THIS MAILING</Fragment> : <Fragment><span className={classes.newText}>NEW</span>CLICK HERE TO SEND ANNIVERSARY NOTES TO <span style={{fontWeight: "bold"}}>{pendingNoteHomeownerCount}</span> Homeowner{pendingNoteHomeownerCount > 1 ? 's' : ''} FOR THIS MAILING</Fragment>}
            customStyle={{
              padding: "8px 16px",
              root: {
                fontSize: "15px",
                fontWeight: "500",
              }
            }}
            onClick={() => {}}
            disabled={isLoading || disabled}
          />
        </CommonConfirmationDialogV2Component>
      )}
    </div>
  );
};

export default withSnackbar(SystemNoteToAllHomeownersComponent);

